import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import MaterialTable from "material-table";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import Paper from "@material-ui/core/Paper";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { IconButton } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import {
  setOverrideLive,
  listenSessionActivity,
  setStudentOverriden,
  setStudentOverrideRequest,
} from "../firebaseApi";
import { Typography } from "@material-ui/core";

const styles = (theme) => ({});

function InstructorCourseOverride(props) {
  let mobile = props.width === "sm" || props.width === "xs";

  const [overrideOn, setOverrideOn] = React.useState(false);
  const [sessionObject, setSessionObject] = React.useState(null);
  const [studentsData, setStudentsData] = React.useState(null);
  const [dialogOpen, setDialogOpen] = React.useState(false);

  React.useEffect(() => {
    if (sessionObject) {
      setOverrideOn(sessionObject?.sessionOverrideLive || false);
    }
  }, [sessionObject?.sessionOverrideLive]);

  function handleButtonClick(status) {
    setOverrideOn(status);
    if (props.course.courseActivitySessionID) {
      let data = {
        sessionID: props.course.courseActivitySessionID,
        status: status,
      };
      setOverrideLive(data);
    }
  }

  React.useEffect(() => {
    if (props.open && props.course.courseActivitySessionID) {
      let data = {
        sessionID: props.course.courseActivitySessionID,
      };
      let unsub = listenSessionActivity(data, (updatedSession) => {
        setSessionObject(updatedSession);
      });

      return () => {
        unsub();
      };
    }
  }, [props.open]);

  React.useEffect(() => {
    if (sessionObject?.students?.length > 0) {
      let studentsList = [];

      for (const student of sessionObject.students) {
        if (student.overrideRequest) {
          let studentData = {};
          studentData["email"] = student.email;
          studentData["firstName"] = student.firstName;
          studentData["lastName"] = student.lastName;
          studentsList.push(studentData);
        }
      }

      setStudentsData(studentsList);
    }
  }, [sessionObject]);

  return (
    <>
      {sessionObject && (
        <Dialog
          disableEscapeKeyDown
          fullScreen={mobile}
          fullWidth
          maxWidth="md"
          open={props.open}
          onClose={() => {
            props.openCtl(false);
          }}
        >
          <DialogTitle>
            {"Override Management of Geolocation for " +
              props.course.courseName}
          </DialogTitle>

          <DialogContent>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="contained"
                color={overrideOn ? "secondary" : "primary"}
                onClick={() => {
                  handleButtonClick(!overrideOn);
                }}
              >
                {overrideOn
                  ? "End geo override requests"
                  : "Solicit geo override requests"}
              </Button>
              <IconButton
                variant="outlined"
                color="primary"
                onClick={() => {
                  setDialogOpen(true);
                }}
              >
                <InfoOutlinedIcon />
              </IconButton>
            </div>

            <MaterialTable
              title=""
              columns={[
                { title: "Email", field: "email", sorting: false },
                { title: "First Name", field: "firstName", sorting: false },
                { title: "Last Name", field: "lastName", sorting: false },
              ]}
              data={studentsData === null ? [] : studentsData}
              icons={{
                Clear: ClearOutlinedIcon,
                Search: SearchOutlinedIcon,
                NextPage: NavigateNextOutlinedIcon,
                PreviousPage: NavigateBeforeOutlinedIcon,
                ResetSearch: ClearOutlinedIcon,
              }}
              components={{
                Container: (props) => <Paper {...props} elevation={0} />,
              }}
              options={{
                showFirstLastPageButtons: false,
              }}
              actions={[
                {
                  icon: DeleteOutlinedIcon,
                  tooltip: "Remove All",
                  isFreeAction: true,
                  onClick: () => {
                    if (sessionObject?.students?.length > 0) {
                      Object.values(sessionObject.students).forEach(
                        (student, index) => {
                          let data = {
                            sessionID: sessionObject.sessionID,
                            studentID: student.id,
                            overrideRequest: false,
                          };
                          setStudentOverrideRequest(data);
                        }
                      );
                    }
                  },
                },
                {
                  icon: AddCircleOutlineIcon,
                  tooltip: "Override",
                  onClick: (event, rowData) => {
                    let data = {
                      sessionID: sessionObject.sessionID,
                      studentID: rowData.email,
                    };
                    setStudentOverriden(data);
                    props.setRerender();
                  },
                },
                {
                  icon: DeleteOutlinedIcon,
                  tooltip: "Remove",
                  onClick: (event, rowData) => {
                    let data = {
                      sessionID: sessionObject.sessionID,
                      studentID: rowData.email,
                      overrideRequest: false,
                    };
                    setStudentOverrideRequest(data);
                  },
                },
              ]}
            />
          </DialogContent>

          <Dialog
            open={dialogOpen}
            onClose={() => {
              setDialogOpen(false);
            }}
          >
            <DialogTitle>
              <Typography style={{ fontSize: "1.3rem" }} color="primary">
                How does Geolocation Override work?
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Typography>
                Geolocation override allows instructors to override the
                geofencing restrictions of a student in cases where it is not
                working properly. This override only counts for the most recent
                or active session in the course. Once you activate the override,
                students who were geofenced will be shown a request button.
                After which you will be able to override individual students
                through the table below.
              </Typography>
            </DialogContent>
            <Button
              onClick={() => {
                setDialogOpen(false);
              }}
              color="primary"
            >
              Close
            </Button>
          </Dialog>

          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                props.openCtl(false);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(
      withWidth()(InstructorCourseOverride)
    )
  )
);
